import LoanSchema, { type LoanData } from '../schemas/loan'
import * as yup from 'yup'
import { type Step } from '@store/reducer.ts'
import type { Installment, VMModel } from '@hooks/type-ds'
import type { Modals } from '@hooks/type-ds'
import type { UserDocument } from '@hooks/type-ds'
import { StepsRichiesta } from './stepsRichiesta'

type RichiestaInsert = 'MANUAL' | 'AUTOMATIC' | 'NONE'

//type Provenienza = 'PRATICA-NO-TOKEN' | 'PREVENTIVATORE' | 'NONE'

export type StartingValues = {
	// parametri URL
	CodiceAffinity: string
	CodiceAffinityEsterno: boolean
	Broker: string | null
	ProductType: string | null
	Product: string | null
	FinancialTable: string | null
	FinancialTableEntry: string | null
	Amount: string
	InstallmentsNumber: string | null
	InstallmentAmount: string
	Token: string | null
	oGUID: string | null
	NAG: string | null
}

export type Token = {
	Provenienza: string
	CurrentStep: number
	IdSimulatore: number
	sessione: string
	StartingValues: StartingValues
	ReqAmount: number
	Amount: number
	MotivationSelected: string
	MotivationDetailSelected: string
	DescrMotivazione: string
	Installments: Installment[]
	SelectedInstallment: Installment | null

	SelectedInstallmentSond: Installment | null
	CocalfinID: number
	Insurance?: boolean | null
	CodicePromozionale: string
	IsSecciVisible: boolean
	eMail: string
	InputToken?: string
	OtherValue?: boolean
	Disclaimer?: string
	NAG?: string
}
export type TrasparenzaResponse = {
	TraspNotReplaced: string
	TraspReplaced?: string
}

type State = {
	IdRichiesta: any
	Provenienza: any
	ComparatoreAssicurata: number | null
	stepInvisible: boolean
	currentStep: Step
	isModify: boolean
	isLanding: boolean
	isReady: boolean
	blockedSelectedSond: boolean
	token: Token
	ocs: {
		NumeroPratica: number
		Controparte: number
	}
	data: {
		currentStep: Step
		StartingValues: StartingValues
		Provenienza: string
		EmailSalvaOfferta: string | null
		Disclaimer: string
		//Insurance:boolean
		sessione: string | null
		IdRichiesta: number
		verifyOTP: boolean
		codiceCliente: number
		cfChecked: string | null
		One: Pick<
			LoanData,
			| 'Amount'
			| 'MotivationSelected'
			| 'MotivationDetailSelected'
			| 'DescrMotivazione'
			| 'SelectedInstallment'
			| 'rataConAssicurazione'
		> & {
			Installments: Installment[]
			CocalfinID: number
			FinancialTable: string
			Prodotto: string
			TipoProdotto: string
			Emettitore: string
			Provenienza: string
			InsuranceComparatore: boolean //inserito questo flag per gestire la presensa di assicurazione quello presente su servizi è per uso interno
			IdentinetEnabled: boolean
			IsSecciVisible: boolean
			Insurance: boolean
		}
		Two: VMModel['Two']
		Three: VMModel['Three']
		Four: VMModel['Four']
		Seven: VMModel['Seven']
		Thanks: {
			done: boolean
		}
	}
	ui: {
		otp: boolean
		progressBar: boolean
		modal: Modals | null
		richiesta: RichiestaInsert
		isCIE: boolean
	}
	servizi: {
		validSurvey: boolean
		insurance: boolean
		heir: boolean
		thirdParty: boolean
		identinetActive: boolean
		identinetContractDuration: string
		beneficiaryEscComm: boolean
		isSecciVisible: boolean
	}
	otpCode: string | null
	errors: {
		app: boolean
		ui: boolean
		modal: boolean
	}
	defaults: Partial<{
		mot: string
		importo: string
		iamount: string
		token: string
		ins: string
		ident: string
		broker: string
		tpprod: string
		prodt: string
		tabfin: string
		nrate: string
		sbToken: string
	}>
	fetching: {
		sources: number
		done: boolean
	}
	validationSchema: yup.ObjectSchema<yup.AnyObject>
	files: Partial<Record<UserDocument, Array<File>>>
	mobileToken: string | null
}

const defaultState: State = {
	IdRichiesta: null, // o un valore iniziale valido
	Provenienza: 'SIMULATORE',
	ComparatoreAssicurata: null,
	stepInvisible: false,
	isModify: false,
	isLanding: false,
	isReady: false,
	blockedSelectedSond: false,
	currentStep: StepsRichiesta.LANDING,
	token: {
		Provenienza: '',
		CurrentStep: 0,
		IdSimulatore: 0,
		sessione: '',
		StartingValues: {
			CodiceAffinity: '',
			CodiceAffinityEsterno: false,
			Broker: null,
			ProductType: null,
			Product: null,
			FinancialTable: null,
			FinancialTableEntry:null,
			Amount: '',
			InstallmentsNumber: null,
			InstallmentAmount: '',
			Token: null,
			oGUID: null,
			NAG: null,
		},
		ReqAmount: 0,
		Amount: 0,
		MotivationSelected: '',
		MotivationDetailSelected: '',
		DescrMotivazione: '',
		Installments: [],
		SelectedInstallment: null,
		SelectedInstallmentSond: null,
		CocalfinID: 0,
		Insurance: false,
		CodicePromozionale: '',
		IsSecciVisible: false,
		eMail: '',
		InputToken: '',
		OtherValue: false,
		Disclaimer: '',
	},
	files: {},
	ocs: {
		NumeroPratica: 0,
		Controparte: 0,
	},
	data: {
		currentStep: StepsRichiesta.LANDING,
		Provenienza: 'SIMULATORE',
		EmailSalvaOfferta: '',
		Disclaimer: '',
		StartingValues: {
			CodiceAffinity: '',
			CodiceAffinityEsterno: false,
			Broker: null,
			ProductType: null,
			Product: null,
			FinancialTable: null,
			FinancialTableEntry: null,
			Amount: '',
			InstallmentsNumber: null,
			InstallmentAmount: '',
			Token: null,
			oGUID: null,
			NAG: null,
		},
		codiceCliente: 0,
		IdRichiesta: 0,
		sessione: null,
		cfChecked: null,
		One: {
			...LoanSchema.cast({}),
			//Amount: 0,
			//MotivationSelected: '',
			//SelectedInstallment: null,
			//rataConAssicurazione: 0,
			CocalfinID: 123,
			FinancialTable: 'tabella',
			Prodotto: 'Prodotto X',
			TipoProdotto: 'Tipo Y',
			Emettitore: 'Emettitore Z',
			Provenienza: 'Provenienza A',
			Installments: [],
			InsuranceComparatore: false,
			IdentinetEnabled: false,
			IsSecciVisible: false,
			Insurance: false,
		},
		Four: {
			CompanyAddress: {
				Address: '',
				AddressNumber: '',
				CAP: '',
				Comune: '',
				ComuneLabel: '',
				Provincia: '',
				ProvinciaLabel: '',
			},
			Activity: '',
			Occupation: '',
			ActivityStartDate: '',
			ActivityEndDate: '',
			ActivityStartMonth: '',
			ActivityEndMonth: '',
			ActivityStartYear: '',
			ActivityEndYear: '',
			ActivitySector: '',
			NetMonthlyIncome: '',
			ContractType: '',
			Monthly: '',
			CompanyName: '',
			CompanyPhone: '',
			CorrentistaBCC: false,
			IBAN: '',
			PEP: false,
		},
		Two: {
			FiscalCode: '',
			FiscalCodeCountry: null,
			Name: '',
			Surname: '',
			IP: '',
			BirthDate: '',
			BirthState: '',
			BirthStateId: '',
			BirthLocation: '',
			BirthLocationId: '',
			Gender: '',
			Marketing: null,
			Profilazione: null,
			MarketingGBCI: null,
			Third: null,
			Privacy: false,
			Sensible: false,
			PEP: false,
			PhoneNumber: '',
			CellNumber: '',
			Email: '',
			ConfirmEmail: '',
			Session: null,
		},
		Three: {
			Citizenship: '',
			CitizenshipType: '',
			CitizenshipExpire: '',
			MaritalState: '',
			HomeType: '',
			RentAmount: '',
			CurrentAddress: {
				Address: '',
				AddressNumber: '',
				CAP: '',
				Comune: '',
				ComuneLabel: '',
				Provincia: '',
				ProvinciaLabel: '',
			},
			PrecAddress: {
				Address: '',
				AddressNumber: '',
				CAP: '',
				Comune: '',
				ComuneLabel: '',
				Provincia: '',
				ProvinciaLabel: '',
			},
			ResidentFrom: '',
			ResidentMonthFrom: '',
			ResidentYearFrom: '',
			Document: {
				DocumentType: '',
				Serial: '',
				DateOfIssue: '',
				IssuingPlace: '',
				Address: {
					Address: '',
					AddressNumber: '',
					CAP: '',
					Comune: '',
					ComuneLabel: '',
					Provincia: '',
					ProvinciaLabel: '',
				},
			},
		},
		Seven: {
			IdSondaggio: -1,
			BenEsclCom: false,
			BenName: '',
			BenCellNumber: '',
			BenEmail: '',
			BenFiscalCode: '',
			BenRelazCli: '',
			BenSurname: '',
			InstallmentsSond: [],
			BenAddress: {
				Address: '',
				AddressNumber: '',
				CAP: '',
				Comune: '',
				ComuneLabel: '',
				Provincia: '',
				ProvinciaLabel: '',
			},
			BenBirthDate: null,
			BenBirthState: null,
			BenBirthStateId: null,
			BenBirthLocation: null,
			BenBirthLocationId: null,
			BenGender: null,
			UltPreferenze: false,
			UltPrfFiscalCode: '',
			UltPrfName: '',
			UltPrfSurname: '',
			UltPrfCellNumber: '',
			UltPrfEmail: '',
			UltPrfAddress: {
				Address: '',
				AddressNumber: '',
				CAP: '',
				Comune: '',
				ComuneLabel: '',
				Provincia: '',
				ProvinciaLabel: '',
			},
			UltPrfBirthDate: null,
			UltPrfBirthState: null,
			UltPrfBirthStateId: null,
			UltPrfBirthLocation: null,
			UltPrfBirthLocationId: null,
			UltPrfGender: null,
			CompletSondaggio: false,
			BenPhoneNumber: '',
			UltPrfPhoneNumber: '',
			SelectedInstallmentSond: {
				InstallmentsCount: 0,
				Amount: 0,
				Tan: 0,
				Taeg: 0,
				PrgSimul: 0,
				Erogato: 0,
				FinanziamLordo: 0,
				ImpServiziFinanz: 0,
				ImpServiziIdentinet: 0,

				Interessi: 0,
				Bollo: 0,
				Rendiconto: 0,
				Istruttoria: 0,
				SpeseGestPrat: 0,
				Dovuto: 0,
			},
			Sondaggio: [],
			nSelectedInstallmentSond: 5,
			MotivationSelected: null,
			SondSelected: false,
			SondApprovato: false,
			SondRisposte: '',
			Beneficiario: false,
			IdentinetActive: false,
			IdentinetContractDuration: null,
		},
		verifyOTP: false,
		Thanks: {
			done: false,
		},
	},
	ui: {
		otp: false,
		progressBar: true,
		modal: null,
		richiesta: 'NONE',
		isCIE: false,
	},
	otpCode: null,
	servizi: {
		insurance: false,
		validSurvey: false,
		heir: false,
		thirdParty: false,
		identinetActive: false,
		identinetContractDuration: '',
		beneficiaryEscComm: false,
		isSecciVisible: false,
	},
	errors: {
		ui: false,
		app: false,
		modal: false,
	},
	defaults: {
		mot: '',
		importo: '',
		iamount: '',
	},
	fetching: {
		sources: 0,
		done: true,
	},
	validationSchema: new yup.ObjectSchema({}),
	mobileToken: null,
}

export { defaultState, type State, type RichiestaInsert }
